export default __webpack_public_path__ + "static/media/STL-Draft-MGT-7-2024-2025.037468f8.pdf";